import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { PropTypes } from 'prop-types'
import UIHighlightedTitle from './UIHighlightedTitle'
import { COLOR_WHITE } from '../../lib/colors'

const UIAdvantages = ({
  dynamicStyle,
  title,
  backgroundColorTitle,
  fontSizeTitle,
  description,
  description2,
}) => {
  return (
    <div className={css(styles.container, dynamicStyle ? dynamicStyle : null)}>
      <UIHighlightedTitle
        value={title}
        backgroundColor={backgroundColorTitle}
        fontSize={fontSizeTitle}
      />
      <p>
        {description} <br /> {description2}
      </p>
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    fontWeight: 700,
    color: COLOR_WHITE,
    '@media (max-width: 480px)': {
      marginBottom: '100px',
    },
  },
})

UIAdvantages.propTypes = {
  dynamicStyle: PropTypes.node,
  title: PropTypes.string,
  backgroundColorTitle: PropTypes.string,
  textColorTitle: PropTypes.string,
  fontSizeTitle: PropTypes.string,
  description: PropTypes.string,
  description2: PropTypes.string,
}

export default UIAdvantages
